const AuditLogAction = Object.freeze({
  create: 'AuditLog_Action_Create',
  update: 'AuditLog_Action_Edit',
  delete: 'AuditLog_Action_Delete',
  pause: 'AuditLog_Action_Pause',
  resume: 'AuditLog_Action_Resume',
  start: 'AuditLog_Action_Start',
  stop: 'AuditLog_Action_Stop',
  close: 'AuditLog_Action_Close'
})
const AuditLogActionLabel = Object.freeze({
  create: 'AuditLog_Action_Created',
  update: 'AuditLog_Action_Changed',
  delete: 'AuditLog_Action_Deleted',
  pause: 'AuditLog_Action_Paused',
  resume: 'AuditLog_Action_Resumed',
  start: 'AuditLog_Action_Started',
  stop: 'AuditLog_Action_Stopped',
  close: 'AuditLog_Action_Closed'
})
const AuditLogSource = Object.freeze({
  manual: 'AuditLog_Source_Manual',
  api: 'AuditLog_Source_API',
  system: 'AuditLog_Source_System'
})
export { AuditLogAction, AuditLogSource, AuditLogActionLabel }



// WEBPACK FOOTER //
// ./src/modules/audit-log/enum/AuditLog.js